import { Utils } from 'jamespot-react-components';

export const tinymceDynamicOptions = JSON.parse(JSON.stringify(J.tinymceDynamicOptions));
export const tinymceExtendedOptions = JSON.parse(JSON.stringify(J.tinymceExtendedOptions));
export const tinymceCommonOptions = Utils.tinymce.initTinyMCEOptions(tinymceDynamicOptions);
